/**
 * Imperative navigation helper (Gatsby `navigate` replacement).
 * Wired to React Router in App via setNavigate().
 */

let navigateImpl = null

export function setNavigate(fn) {
  navigateImpl = fn
}

export function navigate(to, options = {}) {
  if (typeof navigateImpl === `function`) {
    navigateImpl(to, options)
    return
  }
  if (typeof window !== `undefined`) {
    if (options.replace) {
      window.location.replace(to)
    } else {
      window.location.assign(to)
    }
  }
}
